export default "__VITE_ASSET__Baeovwul__"